module.exports = new __parcel__URL__("GenericErrorImage.b96ea332.svg").toString();